import { render, staticRenderFns } from "./CardBrandList.vue?vue&type=template&id=05656f82&scoped=true&"
import script from "./CardBrandList.vue?vue&type=script&lang=js&"
export * from "./CardBrandList.vue?vue&type=script&lang=js&"
import style0 from "./CardBrandList.vue?vue&type=style&index=0&id=05656f82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05656f82",
  null
  
)

export default component.exports